import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

export const DataContext = createContext();
export const DataProvider = ({ children }) => {
    const [userData, setUserData] = useState({});

    const value = {
        userData,
        setUserData,
    };

    return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
export const useData = () => useContext(DataContext);
